(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mph-airmini-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
function inr(v){try{return '₹'+Number(v).toLocaleString('en-IN');}catch(e){return '₹'+v;}}
function sizeShort(s){if(s==='Small')return 'S';if(s==='Medium')return 'M';if(s==='Large')return 'L';return s;}
document.querySelectorAll('.mph-am').forEach(function(root){
if(root.getAttribute('data-mph-am-init')==='1')return;
root.setAttribute('data-mph-am-init','1');
var cfgEl=root.querySelector('[data-mph-am-config]'),varEl=root.querySelector('[data-mph-am-variants]');
if(!cfgEl||!varEl)return;
var cfg,variants;
try{cfg=JSON.parse(cfgEl.textContent);variants=JSON.parse(varEl.textContent)||[];}catch(e){return;}
var tiers=cfg.tiers||[],masks=cfg.masks||[];
function tierByKey(k){for(var i=0;i<tiers.length;i++){if(tiers[i].key===k)return tiers[i];}return tiers[0];}
function maskByKey(k){for(var i=0;i<masks.length;i++){if(masks[i].key===k)return masks[i];}return masks[0];}
function priceForTier(t){for(var i=0;i<variants.length;i++){if(variants[i].option1===t.warrantyOption)return variants[i].price/100;}return null;}
function findVariant(t,m,size){var s=m.sized?size:(m.sizes[0]||'One size');for(var i=0;i<variants.length;i++){var v=variants[i];if(v.option1===t.warrantyOption&&v.option2===m.maskOption&&v.option3===s)return v;}return null;}
var state={tier:(tiers[0]||{}).key,mask:(masks[0]||{}).key,size:null};
function q(s){return root.querySelector(s);}
function qa(s){return root.querySelectorAll(s);}
function setText(s,t){qa(s).forEach(function(el){el.textContent=t;});}
function setBtnLabel(btn,txt){var svg=btn.querySelector('svg');btn.textContent='';if(svg)btn.appendChild(svg);btn.appendChild(document.createTextNode(txt));}
qa('[data-mph-am-tier]').forEach(function(card){var t=tierByKey(card.getAttribute('data-tier'));var p=priceForTier(t);var el=card.querySelector('[data-mph-am-tierprice]');if(el&&p!=null)el.textContent=inr(p);});
function renderSizes(m){var wrap=q('[data-mph-am-sizes]');if(!wrap)return;wrap.innerHTML='';if(!m.sized)return;m.sizes.forEach(function(sz){if(sz==='One size')return;var b=document.createElement('button');b.type='button';b.className='mph-am__sizeopt';b.setAttribute('data-size',sz);b.setAttribute('role','radio');b.setAttribute('aria-checked','false');b.innerHTML=sizeShort(sz)+'<small>'+sz+'</small>';b.addEventListener('click',function(){state.size=sz;render();});b.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();state.size=sz;render();}});wrap.appendChild(b);});}
function render(){
var t=tierByKey(state.tier),m=maskByKey(state.mask);
qa('[data-mph-am-tier]').forEach(function(c){var sel=c.getAttribute('data-tier')===state.tier;c.classList.toggle('is-sel',sel);c.setAttribute('aria-checked',sel?'true':'false');});
qa('[data-mph-am-svcrow]').forEach(function(r){r.classList.toggle('is-active',r.getAttribute('data-tier')===state.tier);});
var md=q('[data-mph-am-maskdesc]');if(md)md.textContent=m.desc;
var sb=q('[data-mph-am-sizeblock]');if(sb){if(m.sized){sb.classList.add('is-show');}else{sb.classList.remove('is-show');state.size=null;}}
qa('[data-mph-am-sizes] .mph-am__sizeopt').forEach(function(s){var sel=s.getAttribute('data-size')===state.size;s.classList.toggle('is-sel',sel);s.setAttribute('aria-checked',sel?'true':'false');});
var price=priceForTier(t);var priceStr=price!=null?inr(price):'';
setText('[data-mph-am-pricebig]',priceStr);setText('[data-mph-am-plantotal]',priceStr);setText('[data-mph-am-stickyprice-amt]',priceStr);
var maskLabel=m.name+(m.sized&&state.size?' · '+state.size:'');
setText('[data-mph-am-planmask]',maskLabel);setText('[data-mph-am-planwarr]',t.warrShort);setText('[data-mph-am-planfree]',t.freeShort);
var maskShort=state.mask.toUpperCase();
setText('[data-mph-am-stickydesc]',cfg.sticky_prefix+t.warrShort+' · '+maskShort+(m.sized&&state.size?' '+state.size:''));
var needsSize=m.sized&&!state.size;
qa('[data-mph-am-add]').forEach(function(b){b.disabled=needsSize;var short=b.getAttribute('data-short')==='true';setBtnLabel(b,needsSize?cfg.labels.needsize:(short?cfg.labels.add_short:cfg.labels.add));});
}
function showToast(txt){var toast=q('[data-mph-am-toast]');if(!toast)return;var t=toast.querySelector('[data-mph-am-toasttxt]');if(t&&txt)t.textContent=txt;toast.classList.add('is-show');clearTimeout(toast._tmr);toast._tmr=setTimeout(function(){toast.classList.remove('is-show');},3600);}
function addToCart(btn){
var t=tierByKey(state.tier),m=maskByKey(state.mask);
if(m.sized&&!state.size)return;
var variant=findVariant(t,m,state.size);
if(!variant||!variant.id){showToast(cfg.labels.err);return;}
var maskProp=m.name+(m.sized&&state.size?' ('+state.size+')':'');
btn.disabled=true;showToast(cfg.labels.toast);
fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:variant.id,quantity:1,properties:{'Mask':maskProp}})}).then(function(r){return r.json();}).then(function(){window.location.href='/checkout';}).catch(function(){btn.disabled=false;showToast(cfg.labels.err);});
}
qa('[data-mph-am-tier]').forEach(function(c){c.addEventListener('click',function(){state.tier=c.getAttribute('data-tier');render();});c.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();state.tier=c.getAttribute('data-tier');render();}});});
var maskSel=q('[data-mph-am-mask]');
if(maskSel){maskSel.addEventListener('change',function(e){state.mask=e.target.value;state.size=null;var m=maskByKey(state.mask);renderSizes(m);render();if(m.sized){var sb=q('[data-mph-am-sizeblock]');if(sb)sb.scrollIntoView({behavior:'smooth',block:'center'});}});}
qa('[data-mph-am-add]').forEach(function(b){b.addEventListener('click',function(){addToCart(b);});});
var mainImg=root.querySelector('.mph-am__main-img');
qa('[data-mph-am-thumb]').forEach(function(th){th.addEventListener('click',function(){if(mainImg&&th.getAttribute('data-full'))mainImg.src=th.getAttribute('data-full');qa('[data-mph-am-thumb]').forEach(function(o){o.classList.remove('is-sel');});th.classList.add('is-sel');});});
renderSizes(maskByKey(state.mask));render();
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mph-collection-masks"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mph-maskcol]').forEach(function(root){
    root.querySelectorAll('.mph-cm__fb').forEach(function(btn){
      btn.addEventListener('click',function(){
        root.querySelectorAll('.mph-cm__fb').forEach(function(x){x.classList.remove('is-on');});
        btn.classList.add('is-on');
        var f=btn.dataset.filter;
        root.querySelectorAll('.mph-cm__m').forEach(function(card){
          var t=card.dataset.mtype;
          card.hidden = !(f==='all' || t==='all' || t===f);
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mph-consumable-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mph-cons]').forEach(function(root){
    var qty=1;
    var inr=new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:2});
    var qval=root.querySelector('[data-qval]'),qin=root.querySelector('[data-qinput]'),line=root.querySelector('[data-line]');
    var price=root.querySelector('[data-cons-price]');
    function base(){
      var sel=root.querySelector('.mph-ch__pack input:checked');
      if(sel)return parseFloat(sel.dataset.price);
      return parseFloat(line?line.dataset.base:'0');
    }
    function draw(){
      if(qval)qval.textContent=qty;
      if(qin)qin.value=qty;
      if(line)line.textContent=inr.format(base()*qty/100);
    }
    var m=root.querySelector('[data-qminus]'),p=root.querySelector('[data-qplus]');
    if(m)m.addEventListener('click',function(){qty=Math.max(1,qty-1);draw();});
    if(p)p.addEventListener('click',function(){qty=qty+1;draw();});
    root.querySelectorAll('.mph-ch__pack input').forEach(function(r){
      r.addEventListener('change',function(){
        root.querySelectorAll('.mph-ch__pack').forEach(function(x){x.classList.remove('is-sel');});
        r.closest('.mph-ch__pack').classList.add('is-sel');
        if(price)price.innerHTML=r.dataset.money+' <small>incl GST</small>';
        draw();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mph-device-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript?null:null;
  document.querySelectorAll('.mph-dh').forEach(function(dh){
    var main=dh.querySelector('[data-mph-main]');
    dh.querySelectorAll('[data-mph-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        if(main){main.src=t.dataset.full;main.removeAttribute('srcset');}
        dh.querySelectorAll('[data-mph-thumb]').forEach(function(x){x.classList.remove('is-sel');});
        t.classList.add('is-sel');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mph-lp-checkquiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mph-lq]').forEach(function(root){
    var res=root.querySelector('[data-lq-res]');
    var wa=root.querySelector('[data-lq-wa]');
    function score(){
      var n=root.querySelectorAll('[data-lq-box]:checked').length;
      var msg;
      if(n===0){res.innerHTML='<b>Tick the boxes above.</b> The more that apply, the more a home sleep test is worth doing.';return;}
      if(n<=2){res.innerHTML='<b>'+n+' ticked — low-to-moderate signs.</b> A home test can give you a clear answer and peace of mind.';}
      else if(n<=4){res.innerHTML='<b>'+n+' ticked — worth checking.</b> These are common signs of sleep apnea. A home test is a simple next step.';}
      else{res.innerHTML='<b>'+n+' ticked — strong signs.</b> We\'d recommend a home sleep test soon — book a slot and we\'ll guide you.';}
      msg='Hi Morpheus, I did the sleep self-check and ticked '+n+' of the signs. I would like to book a home sleep test.';
      if(wa){var base=wa.href.split('?text=')[0];wa.href=base+'?text='+encodeURIComponent(msg);}
    }
    root.querySelectorAll('[data-lq-box]').forEach(function(b){b.addEventListener('change',score);});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mph-mask-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mph-mask]').forEach(function(mh){
    var main=mh.querySelector('[data-mph-main]');
    mh.querySelectorAll('[data-mph-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        if(main){main.src=t.dataset.full;main.removeAttribute('srcset');}
        mh.querySelectorAll('[data-mph-thumb]').forEach(function(x){x.classList.remove('is-sel');});
        t.classList.add('is-sel');
      });
    });
    var price=mh.querySelector('[data-mask-price]');
    mh.querySelectorAll('.mph-mh__size input').forEach(function(r){
      r.addEventListener('change',function(){
        mh.querySelectorAll('.mph-mh__size').forEach(function(s){s.classList.remove('is-sel');});
        r.closest('.mph-mh__size').classList.add('is-sel');
        if(price&&r.dataset.price){price.innerHTML=r.dataset.price+' <small>incl GST</small>';}
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mph-mask-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mph-quiz]').forEach(function(root){
    var mtype=root.dataset.mtype, title=root.dataset.title;
    var ans={};
    var names={full:'a full-face mask',nasal:'a nasal mask',pillow:'a nasal-pillows mask'};
    function reco(){
      if(ans.mouth==null||ans.claustro==null||ans.reads==null)return;
      var rec = ans.mouth==='yes' ? 'full' : ((ans.claustro==='yes'||ans.reads==='yes') ? 'pillow' : 'nasal');
      var res=root.querySelector('[data-quiz-result]');
      var wa=root.querySelector('[data-quiz-wa]');
      var msg;
      if(rec===mtype){
        res.innerHTML='<b>Good match.</b> The '+title+' suits how you sleep. Pick your size above — a coach fits it free before dispatch.';
        msg='Hi Morpheus, the fit quiz says '+title+' is a good match for me. Can a coach confirm my size?';
      } else {
        res.innerHTML='<b>'+names[rec].charAt(0).toUpperCase()+names[rec].slice(1)+' may suit you better.</b> Based on your answers, '+names[rec]+' is often more comfortable — tap below and a coach will confirm the right pick, free.';
        msg='Hi Morpheus, I took the mask fit quiz on '+title+' and it suggests '+names[rec]+'. Can a coach help me choose?';
      }
      if(wa){var base=wa.href.split('?text=')[0];wa.href=base+'?text='+encodeURIComponent(msg);}
    }
    root.querySelectorAll('.mph-mq__opt').forEach(function(btn){
      btn.addEventListener('click',function(){
        var grp=btn.parentElement;
        grp.querySelectorAll('.mph-mq__opt').forEach(function(x){x.classList.remove('is-sel');});
        btn.classList.add('is-sel');
        ans[grp.dataset.q]=btn.dataset.val;
        reco();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mph-therapy-builder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mph-builder]');
  if (!root) return;
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
  var rail = root.querySelector('[data-rail]');
  var phone = root.dataset.phone;
  var emiOn = root.dataset.emi === '1';
  var humidifier = parseInt(root.dataset.humidifier || '0', 10);
  var current = 0, maxVisited = 0;
  var inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });

  function track(name, params) {
    try {
      var payload = Object.assign({ event: name, therapy_type: root.dataset.therapy }, params || {});
      if (typeof window.gtag === 'function') { window.gtag('event', name, payload); }
      else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(payload); }
    } catch (e) {}
  }
  function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function selections() {
    return all('input:checked').filter(function (el) { return el.dataset.kind; }).map(function (el) {
      return { id: el.value, title: el.dataset.title, short: el.dataset.short || el.dataset.title, price: parseInt(el.dataset.price || '0', 10), kind: el.dataset.kind };
    });
  }
  function byKind(k) { return selections().filter(function (s) { return s.kind === k; }); }
  function total() { return selections().reduce(function (a, s) { return a + s.price; }, 0); }
  function emiStr(v) { return 'or ' + inr.format(Math.round(v / 12.13 / 100)) + '/mo · no-cost EMI'; }

  steps.forEach(function (s, i) {
    var li = document.createElement('li');
    li.innerHTML = '<div class="mph-b__rbar"></div><div class="mph-b__rlab"><span class="mph-b__rnum">' + (i + 1) + '</span> ' + s.dataset.stepLabel + '</div>';
    li.addEventListener('click', function () { if (i <= maxVisited) show(i); });
    rail.appendChild(li);
  });

  function renderSidebar() {
    var m = byKind('machine')[0], mk = byKind('mask')[0], cf = byKind('comfort');
    var slm = root.querySelector('[data-sl-machine]'); if (slm) slm.textContent = m ? m.short : '—';
    var slk = root.querySelector('[data-sl-mask]'); if (slk) slk.textContent = mk ? (mk.price > 0 ? mk.short : 'Coach-fitted') : '—';
    var cfr = root.querySelector('[data-sl-comfort-row]');
    if (cfr) { cfr.hidden = cf.length === 0; var cfv = root.querySelector('[data-sl-comfort]'); if (cfv) cfv.textContent = cf.length + ' added'; }
    var reveal = steps[current].dataset.stepName === 'plan';
    var masked = root.querySelector('[data-masked]'), priced = root.querySelector('[data-priced]');
    if (masked) masked.hidden = reveal;
    if (priced) priced.hidden = !reveal;
    var wrap = priced && priced.parentElement; if (wrap) wrap.classList.toggle('is-priced', reveal);
    if (reveal) {
      var t = total();
      all('[data-total]').forEach(function (el) { el.textContent = inr.format(t / 100); });
      all('[data-emi-line]').forEach(function (el) { el.hidden = !emiOn || t === 0; if (emiOn) el.textContent = emiStr(t); });
    }
  }

  function renderPlan() {
    var m = byKind('machine')[0], mk = byKind('mask')[0];
    var t = total();
    var set = function (sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; };
    set('[data-rf-mn]', m ? m.short : '—');
    set('[data-rf-us-m]', m ? inr.format(m.price / 100) : '—');
    set('[data-rf-them-m]', m ? inr.format(Math.round(m.price * 0.94) / 100) : '—');
    var hum = root.querySelector('[data-rf-hum]'); if (hum) hum.textContent = humidifier > 0 ? '+ ' + inr.format(humidifier) + ' add-on' : 'add-on extra';
    if (mk) {
      set('[data-rf-mkn]', mk.price > 0 ? mk.short : 'coach-fitted');
      set('[data-rf-us-mk]', mk.price > 0 ? inr.format(mk.price / 100) : 'fitted free');
      set('[data-rf-them-mk]', mk.price > 0 ? '+ ' + inr.format(Math.round(mk.price * 1.15) / 100) : 'not offered');
    }
    var themTot = (m ? Math.round(m.price * 0.94) : 0) + humidifier * 100 + (mk && mk.price > 0 ? Math.round(mk.price * 1.15) : 0);
    set('[data-rf-them-tot]', themTot > 0 ? inr.format(themTot / 100) + ' + your time' : '—');
    set('[data-rf-us-tot]', inr.format(t / 100) + ' all-in');
    var sel = selections();
    var lines = sel.map(function (i) { return '• ' + i.title + (i.price > 0 ? ' — ' + inr.format(i.price / 100) : ''); });
    var msg = 'Hi Morpheus, here is my therapy plan:\n' + lines.join('\n') + '\nTotal: ' + inr.format(t / 100) + '\nPlease help me take the next step.';
    var wp = root.querySelector('[data-whatsapp-plan]'); if (wp) wp.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
    var co = root.querySelector('[data-checkout]');
    if (co) { var ids = sel.filter(function (i) { return i.id && i.price > 0; }).map(function (i) { return i.id + ':1'; }); co.href = ids.length ? '/cart/' + ids.join(',') : '#'; }
  }

  function gate() {
    steps.forEach(function (s) {
      var btn = s.querySelector('[data-requires]');
      if (!btn) return;
      btn.disabled = byKind(btn.dataset.requires).length === 0;
    });
  }

  function show(i) {
    current = Math.max(0, Math.min(i, steps.length - 1));
    maxVisited = Math.max(maxVisited, current);
    steps.forEach(function (s, idx) { s.hidden = idx !== current; });
    Array.prototype.forEach.call(rail.children, function (li, idx) {
      li.classList.toggle('is-active', idx === current);
      li.classList.toggle('is-done', idx < current);
    });
    var eb = steps[current].querySelector('[data-eyebrow]');
    if (eb) eb.textContent = 'Step ' + (current + 1) + ' of ' + steps.length + ' · ' + eb.textContent.replace(/^Step \d+ of \d+ · /, '');
    root.querySelector('.mph-b__shell').scrollIntoView({ behavior: 'smooth', block: 'start' });
    var name = steps[current].dataset.stepName;
    track('mph_builder_step', { step_number: current + 1, step_name: name });
    if (name === 'plan') { renderPlan(); track('mph_builder_price_reveal', {}); }
    renderSidebar();
  }

  // Mask quiz → recommendation
  function quizReco() {
    var v = function (q) { var el = root.querySelector('[data-q="' + q + '"] .is-sel'); return el ? el.dataset.val : null; };
    var mouth = v('mouth'), claustro = v('claustro'), reads = v('reads');
    var want = mouth === 'yes' ? 'full face' : (claustro === 'yes' || reads === 'yes') ? 'pillow' : 'nasal';
    var reason = mouth === 'yes' ? 'best for mouth-breathers who want a proven all-round seal' : (claustro === 'yes' || reads === 'yes') ? 'minimal on the face — good if you feel closed-in or read in bed' : 'lighter and simpler for nose-breathers';
    var cards = all('[data-mask-card]');
    all('[data-reco-tag]').forEach(function (t) { t.hidden = true; });
    var match = cards.filter(function (c) { return c.dataset.maskTitle.indexOf(want) !== -1; })[0];
    if (!match && want === 'pillow') match = cards.filter(function (c) { return c.dataset.maskTitle.indexOf('p10') !== -1 || c.dataset.maskTitle.indexOf('p30') !== -1; })[0];
    var box = root.querySelector('[data-mask-reco]');
    if (match && box) {
      var tag = match.querySelector('[data-reco-tag]'); if (tag) tag.hidden = false;
      var title = match.querySelector('.mph-b__otit').textContent;
      box.innerHTML = '<b>Your recommended fit: ' + title + '.</b> Based on your answers — ' + reason + '. <b>Fitted free by your coach before dispatch.</b>';
      box.hidden = false;
    } else if (box) { box.hidden = true; }
  }
  all('.mph-b__qopt').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.parentElement.querySelectorAll('.mph-b__qopt').forEach(function (x) { x.classList.remove('is-sel'); });
      btn.classList.add('is-sel');
      quizReco();
    });
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-next]')) show(current + 1);
    if (e.target.closest('[data-back]')) show(current - 1);
    var done = e.target.closest('[data-whatsapp-plan],[data-checkout]');
    if (done) track('mph_builder_complete', { outcome: done.hasAttribute('data-checkout') ? 'checkout' : 'whatsapp' });
  });
  root.addEventListener('change', function () { gate(); renderSidebar(); });

  var params = new URLSearchParams(location.search);
  var pre = params.get('device');
  track('mph_builder_start', { entry: pre ? 'device_pdp' : 'direct' });
  quizReco();
  if (pre) {
    var input = root.querySelector('input[data-handle="' + pre + '"]');
    if (input) { input.checked = true; gate(); show(1); return; }
  }
  show(0); gate();
})();

  } catch(e) { console.error(e); }
})();
})();
